import script from "./UmbracoFormFieldset.vue?vue&type=script&setup=true&lang=ts"
export * from "./UmbracoFormFieldset.vue?vue&type=script&setup=true&lang=ts"

import "./UmbracoFormFieldset.vue?vue&type=style&index=0&id=37ef3530&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ef3530"]])

export default __exports__